<template>
  <div :class="rootClass">
    <div
      v-if="thumbnailPath"
      class="thumbnail-container content"
    >
      <div
        v-if="isLoading"
        class="spinner-container"
      >
        <b-spinner
          variant="secondary"
          type="grow"
          label="Spinning"
        />
      </div>
      <div
        v-show="!isLoading"
        class="links-wrapper"
      >
        <a
          v-b-tooltip.hover.viewport.noninteractive="'Download'"
          :href="item.full_url"
          download
          @click.stop
        >
          <b-icon icon="download" />
        </a>
        <a
          v-b-tooltip.hover.viewport.noninteractive="'View'"
          href="#"
          @click.prevent.stop="openViewer"
        >
          <b-icon icon="zoom-in" />
        </a>
      </div>
      <img
        v-show="!isLoading"
        :src="thumbnailPath"
        alt="product-thumbnail"
        onError="this.src='/images/image.svg'"
        @load="onLoad"
      >
    </div>
    <div
      v-if="!thumbnailPath"
      class="d-flex justify-content-center align-items-center w-100 h-100 content"
      v-html="drawFileSvg(item)"
    />
  </div>
</template>

<script>
import { drawFileSvg } from '@frontend/utils';
import { TYPE } from '@frontend/constants/file-image-types';
import 'viewerjs/dist/viewer.min.css'
import { api as viewerApi } from 'v-viewer'
import { mapGetters } from 'vuex'

export default {
  name: "ItemView",
  props: {
    item: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      isLoading: true
    }
  },
  computed: {
    ...mapGetters('productImageSelector', [
      'items',
    ]),
    viewerImages () {
      return this.items
          .filter(item => item.type !== TYPE.FOLDER)
          .map(item => ({
            id: item.id,
            src: item.thumbnail_path || item.url || item.path,
            dataSource: item.full_url,
          }))
    },
    rootClass() {
      return this.item.type === TYPE.FOLDER ? 'folder' : 'image';
    },
    thumbnailPath() {
      return this.item.thumbnail_path || this.item.url || this.item.path;
    }
  },
  methods: {
    drawFileSvg: drawFileSvg,
    onLoad() {
      this.isLoading = false;
    },
    openViewer () {
      viewerApi({
        options: {
          url: 'dataSource',
          initialViewIndex: _.findIndex(this.viewerImages, ['id', this.item.id]),
        },
        images: this.viewerImages,
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.thumbnail-container {
  display: flex;

  img {
    flex-grow: 1;
    object-fit: contain;
  }
}

.c-grid-view-item__preview {
  .links-wrapper {
    display: none;
    position: absolute;
    top: .25rem;
    left: .5rem;

    :hover > & {
      display: flex;
      flex-direction: column;
    }
  }
}

.c-file-browser {
  .content {
    img, svg {
      max-width: 175px;
      max-height: 80px;
    }

    svg {
      width: 30px;
    }
  }

  .image {
    width: 100%;

    svg {
      width: auto;
    }
  }

  .spinner-container {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .folder {
    .content {
      width: 100% !important;
      height: 100px !important;
      background-color: rgb(240, 242, 244, 0.3);

      // The glyph arrives through `v-html`, so it carries no scope attribute — plain selectors
      // here would never match it.
      ::v-deep .folder-icon-preview {
        max-height: 80px;

        svg {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
